import { useEffect } from 'react';
import Highcharts from 'highcharts';
import Tree from 'highcharts/modules/treemap';
import exporting from 'highcharts/modules/exporting';
import data from 'highcharts/modules/data';
import Heatmap from 'highcharts/modules/heatmap';

Tree(Highcharts);
data(Highcharts);
Heatmap(Highcharts);
exporting(Highcharts);

const QALikes = () => {
  const initialChart = () => {
    Highcharts.chart('QALikes', {
      chart: {
        type: 'column',
      },

      title: {
        text: 'Likes',
      },

      xAxis: {
        type: 'category',
      },

      yAxis: {
        allowDecimals: true,
        min: 0,
        stackLabels: {
          enabled: true,
        },
        labels: {
          formatter: function () {
            return this.value;
          },
        },
        title: {
          text: null,
        },
      },

      credits: {
        enabled: false,
      },

      tooltip: { enabled: false },

      colors: ['#005cb1'],

      plotOptions: {
        column: {
          stacking: 'normal',
          groupPadding: 0,
          pointPadding: 0,
          shadow: false,
          borderWidth: 0,
        },
        series: {
          enableMouseTracking: false,
        },
      },

      series: [
        {
          name: 'Likes',
          data: [
            ['7 Oct', 25],
            ['8 Oct', 51],
            ['9 Oct', 20],
            ['10 Oct', 20],
            ['11 Oct', 44],
            ['12 Oct', 77],
            ['13 Oct', 81],
          ],
        },
      ],
    });
  };

  useEffect(() => {
    initialChart();
  }, []);

  return <div id="QALikes" className="col-lg-3" />;
};

export default QALikes;
